<ng-container *ngIf="!isLoadingLabels">
	<div class="search-filter-container">
		<ng-container
			*ngIf="!isLoadingAvailableFilters && !isLoadingCiType && availableCmdbFiltersIAC && availableCmdbFiltersIAC.length > 0">
			<div class="title">{{ labels.lbl_filtros_de_busca }}</div>

			<div class="tags-container">
				<div
					class="tag"
					[title]="labels.lbl_max_100_itens_filtre_itens_especificos"
					(click)="notify(labels.lbl_max_100_itens_filtre_itens_especificos)"
					*ngIf="searchCis === true">
					100 {{ labels.lbl_geral_itens }}
				</div>
				<div class="tag" *ngIf="ciType.id">
					{{ labels[ciType.label] ? labels[ciType.label] : ciType.label }}
				</div>
				<div class="tag" *ngIf="!ciType.id && selectedFilters && selectedFilters.length === 0">
					{{ labels.lbl_nenhum_filtro_selecionado }}
				</div>
				<div
					class="tag"
					[ngClass]="{ undeletable: tag.undeletable }"
					(click)="tag.undeletable ? null : deleteTag(index)"
					*ngFor="let tag of selectedFilters; let index = index">
					<span>{{ tag.label && labels[tag.label] ? labels[tag.label] : tag.name }}</span>
					<span *ngIf="!tag.undeletable"><fa-icon [icon]="icons.faTimes"></fa-icon></span>
				</div>
			</div>
			<cpi-input-with-autocomplete
				[availableOptions]="availableCmdbFiltersIAC"
				[placeholder]="labels.lbl_geral_selecione"
				[minInputLength]="0"
				[inputHeight]="'30px'"
				[keepValue]="false"
				(onValueChange)="setTag($event)"
				(setValue)="(null)"
				[idGen]="'iacCmdbSearchFilter'">
			</cpi-input-with-autocomplete>

			<div class="tip mb-2">{{ labels.lbl_adicionar_filtros_personalizados }}</div>

			<ng-container *ngFor="let formItem of selectedFilters; let index = index">
				<div
					class="input-cell"
					*ngIf="
						formItem.inputType === 'string' ||
						formItem.inputType === 'number' ||
						formItem.inputType === 'date' ||
						formItem.inputType === 'select' ||
						formItem.inputType === 'boolean'
					">
					<span>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}</span>
					<select class="min-width" (change)="formItem.operator = $event.target.value" *ngIf="formItem.name !== 'type'">
						<option [value]="''" [selected]="formItem.operator === ''">{{ labels.lbl_geral_contendo }}</option>
						<option [value]="'!'" [selected]="formItem.operator === '!'">{{ labels.lbl_geral_diferente_de }}</option>
					</select>
					<div *ngIf="formItem.inputType === 'string' || formItem.inputType === 'number' || formItem.inputType === 'date'">
						<input
							[type]="formItem.inputType"
							[value]="formItem.values[0]"
							(input)="
								multiOptionSelect && formItem.inputType !== 'date'
									? handleMultiOptionValue(index, $event)
									: (formItem.values[0] = $event.target.value)
							"
							(change)="
								multiOptionSelect ? handleMultiOptionValue(index, $event) : (formItem.values[0] = $event.target.value)
							"
							[disabled]="formItem.unchangeable"
							[attr.min]="formItem.inputType === 'number' ? '0' : null"
							#commonInput />
						<span
							class="button"
							(click)="handleMultiOptionValue(index, $event)"
							*ngIf="multiOptionSelect && (formItem.inputType === 'string' || formItem.inputType === 'number')"
							><fa-icon [icon]="icons.faPlus"></fa-icon
						></span>
					</div>
					<select
						(change)="
							multiOptionSelect && formItem.name !== 'type'
								? handleMultiOptionValue(index, $event)
								: (formItem.values[0] = $event.target.value);
							formItem.name === 'type' && formItem.commonGroup === '1A'
								? getFilterAndCi(customer, $event.target.value, false)
								: null
						"
						[disabled]="formItem.unchangeable"
						*ngIf="formItem.inputType === 'select' || formItem.inputType === 'boolean'">
						<option [value]="-1" selected>{{ labels.lbl_geral_selecione }}</option>
						<option
							[value]="selectOption.values[0]"
							[selected]="
								multiOptionSelect && formItem.name === 'type' && formItem.values[1] != undefined
									? selectOption.values[0].toString() === formItem.values[1].toString()
									: selectOption.values[0].toString() === formItem.values[0].toString()
							"
							*ngFor="let selectOption of formItem.items">
							<!--- [selected] tem um caso só para type. --->
							{{
								labels[selectOption.label]
									? labels[selectOption.label]
									: selectOption.name
										? selectOption.name
										: selectOption.value
							}}
						</option>
					</select>
				</div>

				<div class="input-cell vertical" *ngIf="formItem.inputType === 'textarea'">
					<span>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }} {{ formItem.required ? '*' : '' }}:</span>
					<textarea rows="4" [value]="formItem.values[0]" (input)="formItem.values[0] = $event.target.value"></textarea>
				</div>

				<!---<div class="input-cell vertical" *ngIf="formItem.inputType === 'readCode'">
                    <span>{{labels[formItem.label] ? labels[formItem.label] : formItem.name}} {{formItem.required ? '*' : ''}}:</span>
                    <div>
                        <select class="min-width" (change)="formItem.operator = $event.target.value" *ngIf="formItem.name != 'type'">
                            <option [value]="''" [selected]="formItem.operator === ''">{{labels.lbl_geral_contendo}}</option>
                            <option [value]="'!'" [selected]="formItem.operator === '!'">{{labels.lbl_geral_diferente_de}}</option>
                        </select>
                        <input
                        [type]="formItem.inputType"
                        [value]="formItem.values[0]"
                        (input)="multiOptionSelect ? (handleMultiOptionValue(index, $event)) : (formItem.values[0] = $event.target.value)"
                        (change)="multiOptionSelect ? (handleMultiOptionValue(index, $event)) : (formItem.values[0] = $event.target.value)"
                        [disabled]="formItem.unchangeable"
                        [attr.min]="formItem.inputType === 'number' ? '0' : null"
                        #commonInput>
                        <span class="button" (click)="handleMultiOptionValue(index, $event)" *ngIf="multiOptionSelect"><fa-icon [icon]="icons.faPlus"></fa-icon></span>
                    </div>
                    <cpi-qrcode
                    [startButtonLabel]="labels.lbl_geral_ler + ' ' + (formItem.name === 'qrcode' ? labels.lbl_geral_qrcode : labels.lbl_geral_barcode)"
                    [stopButtonLabel]="labels.lbl_geral_parar"
                    (getQrcodeData)="multiOptionSelect ? (handleMultiOptionValue(index, $event, true)) : (formItem.values[0] = $event)">
                    </cpi-qrcode>
                </div>--->

				<div class="multi-select-box" *ngIf="multiOptionSelect && formItem.name !== 'type' && formItem.values.slice(1).length > 0">
					<span *ngFor="let item of formItem.outItems; let itemIndex = index" (click)="removeMultiOptionValue(index, itemIndex)">
						<fa-icon [icon]="icons.faAngleRight"></fa-icon>
						{{ labels[item.label] ? labels[item.label] : item.name ? item.name : (item | visualFormat: formItem.inputType) }}
					</span>
				</div>
			</ng-container>

			<div class="button-container" *ngIf="searchCis">
				<div [ngClass]="{ disabled: isLoadingCiList }" class="button" (click)="updateFilters()">
					{{ labels.lbl_geral_pesquisar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isLoadingCiList"></cpi-dot-bounce-loading-effect>
				</div>
				<!-- <div class="button" (click)="readingQrCode = true; setTag('qrcode,1A')" *ngIf="!readingQrCode">{{labels.lbl_geral_ler + ' ' + labels.lbl_geral_qrcode}}</div>
                <div class="button" (click)="readingBarCode = true; setTag('barcode,1A')" *ngIf="!readingBarCode">{{labels.lbl_geral_ler + ' ' + labels.lbl_geral_barcode}}</div> -->
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect
			class="mt-2"
			[color]="'var(--primary-color-2)'"
			*ngIf="isLoadingAvailableFilters || isLoadingCiType || !availableCmdbFiltersIAC"></cpi-dot-bounce-loading-effect>
	</div>
</ng-container>

<div class="mt-2">
	<ng-container *ngIf="!isLoadingCiList && ciListIAC && ciListIAC.length >= 0">
		<span class="tip">{{ labels.lbl_aqui_resultados_filtros_cima }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="ciListIAC"
			[placeholder]="labels.lbl_geral_selecione"
			[minInputLength]="0"
			[inputHeight]="'30px'"
			(onValueChange)="emitSelectedCi($event)"
			[cleanValues]="cleanComponent"
			[keepValue]="keepSelectedCi"
			*ngIf="!isLoadingCiList && ciListIAC && ciListIAC.length > 0">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			class="mt-2"
			[header]="searchHeader"
			[body]="ciList.ciArray"
			[height]="'30dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			[markLastSelectedItem]="true"
			(getSelectedItem)="emitSelectedCi($event[0]['cmdb_id'])"
			*ngIf="!isLoadingCiList && ciListIAC && ciListIAC.length > 0">
		</cpi-msp-table>
	</ng-container>

	<div class="not-found" *ngIf="!isLoadingCiList && ciListIAC && ciListIAC.length === 0">
		{{ labels.lbl_security_nenhum_registro }}
	</div>
	<!-- <cpi-dot-bounce-loading-effect [color]="'var(--primary-color-2)'" class="mb-3" *ngIf="isLoadingCiList"></cpi-dot-bounce-loading-effect> -->
</div>

<cpi-dot-bounce-loading-effect class="mt-2" [color]="'var(--primary-color-2)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
